import React from 'react';
import { Badge, IconButton, makeStyles } from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import { useSelector, useDispatch } from 'src/store';
import { toggleCart } from 'src/slices/cart';
import { Theme } from 'src/theme';

const useStyles = makeStyles((theme: Theme) => ({
  cartIcon: {
    color: 'white',
    transition: 'color 0.2s ease-in-out',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.palette.secondary.main,
      color: 'white',
      fontSize: '0.75rem',
      fontWeight: 600,
      minWidth: 20,
      height: 20,
      borderRadius: 10,
    },
  },
}));

const CartIcon: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { totalItems } = useSelector((state) => state.cart);

  const handleCartClick = () => {
    dispatch(toggleCart());
  };

  return (
    <IconButton onClick={handleCartClick} className={classes.cartIcon} data-testid="cart-icon">
      {totalItems > 0 ? (
        <Badge badgeContent={totalItems} className={classes.badge}>
          <ShoppingCart />
        </Badge>
      ) : (
        <ShoppingCart />
      )}
    </IconButton>
  );
};

export default CartIcon;

